export class PublicFn {
    constructor() {

    }
    formatNum(value) {
        if (!value && value !== 0) return 0;

        let str = value.toString();
        let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
        return str.replace(reg, "$1,");
    }
    // 千分位
    formatNumber(num) {
        if (isNaN(num)) {
          return num;
        }

        var groups = (/([\-\+]?)(\d*)(\.\d+)?/g).exec("" + num),
            mask = groups[1],            //符号位 
            integers = (groups[2] || "").split(""), //整数部分 
            decimal = groups[3] || "",       //小数部分 
            remain = integers.length % 3;

        var temp = integers.reduce(function (previousValue, currentValue, index) {
            if (index + 1 === remain || (index + 1 - remain) % 3 === 0) {
                return previousValue + currentValue + ",";
            } else {
                return previousValue + currentValue ;
            }
        }, "").replace(/\,$/g, "");
        num = mask + temp + decimal
        return num;
    }

    dealListCodeName(list, code_key, code_name) {
        if (list && list.length > 0) {
            list.forEach(item => {
                item.code = item[code_key];
                item.name = `${item.code}-${item[code_name]}`;
            })
        }
        return list;
    }

    // 格式化数字(k w)
    formatNumberAddUnit(num, n = 0) {
        if (num && num > 0) {
            // return num >= 1e3 && num < 1e4 ? (num / 1e3).toFixed(n) + 'k' : num >= 1e4 ? (num / 1e4).toFixed(n) + 'w' : num
            return num >= 1e3 && num < 1e4 ? (num / 1e3) + 'k' : num >= 1e4 ? (num / 1e4) + 'w' : num
        } else {
            return num.toFixed(n);
        }
    }
    // 格式化数字(K,M)
    formatNumberAddUnit2(num, n = 0) {
        if(Number(num)>0){
            const si = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: "K" },
                { value: 1E6, symbol: "M" },
                { value: 1E9, symbol: "B" }
            ];
            let i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }
            return (num / si[i].value).toFixed(n) + si[i].symbol;
        }else{
            return num
        }
        
    }

    // 获取文件大小
    getFileSize(fileByte) {
        var fileSizeByte = fileByte;
        var fileSizeMsg = "";
        if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB";
        else if (fileSizeByte == 1048576) fileSizeMsg = "1MB";
        else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB";
        else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB";
        else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB";
        else fileSizeMsg = "文件超过1TB";
        return fileSizeMsg;
    }


    /**
     * 通过data得到table的heade列表
     * @param {*} data 
     */
    dealDataGetHeaders(data, widthMap, cb) {
        let header = [];
        if (data && data.length > 0) {
            data.some(item => {
                Object.keys(item).forEach(key => {
                    let th = {
                        title: key.replace(/^\w/i, function (i) { return i.toLocaleUpperCase() }),
                        dataIndex: key,
                        key: key,
                        sorter: true,
                        sortDirections: ['descend', 'ascend'],
                        align: !isNaN(item[key]) ? 'left' : 'left',
                        scopedSlots: {customRender: ''},
                    }
                    if (cb) {
                        th = cb(th)
                    }
                    if (widthMap[key]) {
                        th.width = widthMap[key]
                    } else {
                        let str = item[key].length > key.length ? item[key] : key;
                        th.width = str.length * 10 < 120 ? 120 : str.length * 10 > 220 ? 220 : str.length * 10
                    }
                    header.push(th)

                })
                return true;
            })
        }
        return header
    }
    dealDataGetHeaders2(data, widthMap, cb) {
        let header = [];
        if (data && data.length > 0) {
            data.some(item => {
                Object.keys(item).forEach(key => {
                    let th = {
                        title: key.replace(/^\w/i, function (i) { return i.toLocaleUpperCase() }),
                        dataIndex: key,
                        key: key,
                        sorter: true,
                        width:150,
                        sortDirections: ['descend', 'ascend'],
                        align: !isNaN(item[key]) ? 'left' : 'left',
                        scopedSlots: {customRender: ''},
                    }
                    if (cb) {
                        th = cb(th)
                    }
                  
                    header.push(th)

                })
                return true;
            })
        }
        return header
    }
    /**
     * 模拟下载流
     * @param {*} url 
     * @param {*} filename 
     */
    downloadFile(url, filename,str) {
        let a = document.createElement('a');
        if(str&&str=='pdf'){
            a.target='_blank'
        }
      
        a.href = url;
        a.download = filename;
        a.click();
    }

    debounce(fn, delay) {
        var timeout = null; // 创建一个标记用来存放定时器的返回值
        return function (e) {
            // 每当用户输入的时候把前一个 setTimeout clear 掉
            clearTimeout(timeout);
            // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
            timeout = setTimeout(() => {
                fn.apply(this, arguments);
            }, delay);
        }
    }
    //节流throttle代码：
    throttle(fn, delay) {
        let canRun = true; // 通过闭包保存一个标记
        return function () {
            // 在函数开头判断标记是否为true，不为true则return
            if (!canRun) return;
            // 立即设置为false
            canRun = false;
            // 将外部传入的函数的执行放在setTimeout中
            setTimeout(() => {
                // 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。
                // 当定时器没有执行的时候标记永远是false，在开头被return掉
                fn.apply(this, arguments);
                canRun = true;
            }, delay);
        };
    }

    // 随机大写字母
    generateBig() {
        var str = [];
        for (var i = 65; i < 91; i++) {
            str.push(String.fromCharCode(i));
        }
        return str;
    }
    // 随机小写字母
    generateSmall() {
        var str = [];
        for (var i = 97; i < 123; i++) {
            str.push(String.fromCharCode(i));
        }
        return str;
    }
    getRandomLetter(len) {
        let letterList = [...this.generateBig.call(this), ...this.generateSmall.call(this)]
        let str = [];
        for (let i = 0; i < len; i++) {
            str.push(letterList[Math.floor(Math.random() * letterList.length)])
        }
        return str;
    }
    getRandomNumber(len) {
        let letterList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        let str = [];
        for (let i = 0; i < len; i++) {
            str.push(letterList[Math.floor(Math.random() * letterList.length)])
        }
        return str;
    }
    getRandomNumberOrLetter(len) {
        let letterList = [...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], ...this.generateBig(), ...this.generateSmall()];
        let str = [];
        for (let i = 0; i < len; i++) {
            str.push(letterList[Math.floor(Math.random() * letterList.length)])
        }
        return str;
    }
    // 通过code获取name
    getNameByCode(list, value, c_key = 'value', n_key = 'label') {
        if (list && value) {
            let item = list.filter(item => item[c_key] == value)[0];
            return item ? item[n_key] : 'Empty'
        } else {
            return value;
        }
    }
    filterParams(params) {
        let _newPar = {};
        for (let key in params) {
            //如果对象属性的值不为空，就保存该属性（这里我做了限制，如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
            if ((params[key] === 0 || params[key]) && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
                //记录属性
                _newPar[key] = params[key];
            }
        }
        //返回对象
        return _newPar;
    }
    // 删除空余字段
    delUnkey(params) {
        let obj = {};
        Object.keys(params).forEach(k => {
            if (params[k] || params[k] === 0) {
                obj[k] = JSON.parse(JSON.stringify(params[k]));
            }
        })
        return obj;
    }

    // 前端分页
    dealPanByCode({ data, page, size }) {
        data = JSON.parse(JSON.stringify(data))
        if (data && data.length > 0) {
            return data.splice((page - 1) * size, size)
        } else {
            return data;
        }
    }

    // 深度拷贝
    _clone(obj) {
        return JSON.parse(JSON.stringify(obj))
    }

    isBlank(obj) {
        return obj === undefined || obj === null || obj.length === 0
    }
    formatDateTime(time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        var second = date.getSeconds()
        minute = minute < 10 ? '0' + minute : minute
        second = second < 10 ? '0' + second : second
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    }

    formatDateTime_1(time) {
        var date = new Date(time)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        return y + '' + m + '' + d
    }

    getBeforeDay(day) {
        var today = new Date()
        var targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetdayMilliseconds)
        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()

        function doHandleMonth(month) {
            var m = month
            if (month.toString().length === 1) {
                m = '0' + month
            }
            return m
        }

        tMonth = doHandleMonth(tMonth + 1)
        tDate = doHandleMonth(tDate)
        return tYear + '-' + tMonth + '-' + tDate
    }
    toThousands(num) {
        var result = []
        var counter = 0
        num = (num || 0).toString()
        var pointI = num.indexOf('.')
        var decimal = ''
        if (pointI !== -1) {
            decimal = num.substring(pointI)
            num = num.substring(0, pointI)
        }
        var minus = num.indexOf('-')
        if (minus !== -1) {
            num = num.substring(1)
        }
        num = num.split('')
        for (var i = num.length - 1; i >= 0; i--) {
            counter++
            result.unshift(num[i])
            if (!(counter % 3) && i !== 0) {
                result.unshift(',')
            }
        }
        if (decimal !== '') {
            result.push(decimal)
        }
        if (minus !== -1) {
            result.unshift('-')
        }

        return result.join('')
    }
    firstLetterToLower(word) {
        let a = word.split('')
        let b = a[0].toLowerCase()
        a.splice(0, 1, b)
        return a.join('')
    }

    // // 格式化数字
    // formatNumber(num) {
    //     var pointI = num.indexOf('.')
    //     if (pointI > -1) {
    //         decimal = num.substring(pointI)
    //         num = num.substring(0, pointI)
    //     }
    //     return num
    // }
    generate_password(length) {
        var x = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXY';
        var tmp = '';
        var l = length || 6;
        for(var i = 0; i < l; i++)  {
            tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length);
        }
        return  tmp;
    }

    // 邮箱正则校验
    validateEmailFuc(val) {
        let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@+([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]$/;
        if(!reg.test(val)) return true
        else return false
    }
    // 时间相差天数计算
    getDiffDay(date_1, date_2) {
        let totalDays, diffDate;
        let myDate_1 = Date.parse(date_1);
        let myDate_2 = Date.parse(date_2);
        diffDate = Math.abs(myDate_1 - myDate_2);
        totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) ;
        return totalDays;    // 相差的天数
    }

}


const b = new PublicFn()
export default b



// WEBPACK FOOTER //
// ./src/util/toolClass/publicFn.js